import { createApp, h } from 'vue';
import Sliders from '@components-molecules/Sliders.vue';

export const sliderManager = () => {
  const container = document.createElement('div');
  document.body.appendChild(container);
  const component = {
    render: () => h(Sliders),
  };

  return createApp(component).mount(container);
};
